import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ServicePage from "@/pages/ServicePage";
import CoursePage from "@/pages/CoursePage";
import Quiz from "@/pages/Quiz";
import QRCard from "@/pages/QRCard";
import StudioPass from "@/pages/StudioPass";
import Method from "@/pages/Method";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Vault from "@/pages/Vault";
import Manual from "@/pages/Manual";
import ScrollToTop from "@/components/site/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servicios/:slug" element={<ServicePage />} />
              <Route path="/cursos/:slug" element={<CoursePage />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/qr" element={<QRCard />} />
              <Route path="/studio-pass/:token" element={<StudioPass />} />
              <Route path="/method" element={<Method />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<Article />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/vault/:token" element={<Vault />} />
              <Route path="/academia/:token" element={<Manual />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#1A1A1A",
                  color: "#FAFAFA",
                  border: "1px solid #2a2a2a",
                  borderRadius: 0,
                  fontFamily: "Outfit, sans-serif",
                  fontSize: 13,
                  letterSpacing: "0.04em",
                },
              }}
            />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
